import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Disc3 } from 'lucide-react';

export default function Login() {
  const { login } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-b from-[#0b0d10] via-[#0e1216] to-[#0b0d10]">
      <Card className="w-full max-w-md" data-testid="login-card">
        <CardHeader className="space-y-1 text-center">
          <div className="flex justify-center mb-4">
            <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center">
              <Disc3 className="h-6 w-6 text-primary" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold">Welcome to RecordRinse.com</CardTitle>
          <CardDescription>Existing users can sign in to upload and process audio. New sign-ups are currently disabled.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button 
            onClick={login} 
            className="w-full"
            size="lg"
            data-testid="login-button"
          >
            Sign in to continue
          </Button>
          <p className="text-xs text-center text-muted-foreground">
            Sign in with Google, GitHub, Apple, or email
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
